export default "__VITE_ASSET__AST9cm9T__"